module.exports = __webpack_public_path__ + "img/logos.f42a2a61.png";